import React from 'react';
import { useTranslation } from '../i18n';

const LanguageSwitcher = () => {
  const { lang, setLang } = useTranslation();
  
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <button
        onClick={() => setLang('fr')}
        style={{
          padding: '6px 12px',
          borderRadius: '6px',
          border: 'none',
          background: lang === 'fr' ? '#DC2626' : 'transparent',
          color: lang === 'fr' ? 'white' : 'var(--text-muted)',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '600',
          transition: 'all 0.2s'
        }}
      >
        🇫🇷 FR
      </button>
      <button
        onClick={() => setLang('en')}
        style={{
          padding: '6px 12px',
          borderRadius: '6px',
          border: 'none',
          background: lang === 'en' ? '#DC2626' : 'transparent',
          color: lang === 'en' ? 'white' : 'var(--text-muted)',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '600',
          transition: 'all 0.2s'
        }}
      >
        🇬🇧 EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;

